<template>
    <b-modal
            size="md"
            :visible="show"
            @hidden="hideEvents"
            :id="modalId"
            :title="title"
            class="file-type-modal"
    >
        <vue-element-loading :active="loading"></vue-element-loading>
        <r-form
                :column-size="1"
                :crud="true"
                :validators="validators"
                :showHeader="false"
                :showFooter="false"
                ref="form"
                v-model="form"
                @save="save"
                :disabled="false"
                v-if="form"
        >
        </r-form>
        <template slot="modal-footer">
            <b-button
                    variant="outline-secondary"
                    class="cancel"
                    @click="hideModal">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                    variant="yellow"
                    @click="save"
            >
                {{ buttonText }}
                <font-awesome-icon
                        class="ml-3"
                        :icon="['fal', 'upload']"
                >
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { forEach } from 'lodash';
import ModalMixin from '@/components/Modal/ModalMixin';
import FileDropMixin from '@/components/Form/FileDropMixin';
import { form as PropertyFileTypeForm, validators as PropertyFileTypeValidators } from '@/services/Property/PropertyFileTypeForm';
import RForm from '@/components/Form/RiskhubForm';
import PropertyDocument from '../../services/Property/PropertyDocument';
import dayjs from 'dayjs';

export default {
  name: 'File-Type-Modal',
  components: {
    RForm,
  },
  props: {
    show: {
      default: false,
    },
    buttonText: {
      default: 'Save',
    },
    propertyId: {
      type: Number,
    },
    propertyDocumentId: {
      type: Number,
    },
    expiryDateRequired: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [FileDropMixin, ModalMixin],
  data() {
    return {
      modalId: 'fileTypeUpdate',
      validators: PropertyFileTypeValidators,
      form: null,
      title: '',
      expiryDateValidator: PropertyFileTypeValidators.expiryDate,
      issueDateValidator: PropertyFileTypeValidators.issueDate,
    };
  },
  mounted() {
    this.fetch(this.propertyId, this.propertyDocumentId);
    this.manageRequiredFields();
  },
  watch: {
    'form.propertyFileTypeId.value.propertyFileTypeId': {
      handler() {
        this.manageRequiredFields();
      },
    },
  },
  methods: {
    async manageRequiredFields() {
      const form = await this.form;

      PropertyFileTypeValidators.expiryDate = this.expiryDateValidator;
      PropertyFileTypeValidators.issueDate = this.issueDateValidator;

      if (form) {
        // If the selected type does not require an expiry date, we remove it from
        // the validator.
        if (!form.propertyFileTypeId.value.hasExpiryDate) {
          PropertyFileTypeValidators.expiryDate = {
            required: false,
          };
        }

        if (!form.propertyFileTypeId.value.hasIssueDate) {
          PropertyFileTypeValidators.issueDate = {
            required: false,
          };
        }
      }
    },
    async fetch(propertyId, propertyDocumentId) {
      this.loading = true;
      this.propertyDocument = [];

      try {
        const response = await PropertyDocument.find(propertyId, propertyDocumentId);
        this.propertyDocument = response.data.data;

        this.title = await (this.propertyDocument.filename);

        this.setPropertyDocumentForm();
      } catch (e) {
        this.$router.push({ name: 'propertyDocument' }, () => {
          this.$notify({
            title: 'Property document not found',
            text: 'Property document could not be found.',
            type: 'error',
          });
        });
      } finally {
        this.loading = false;
      }
    },
    setPropertyDocumentForm() {
      const form = PropertyFileTypeForm();
      const { propertyDocument } = this;

      forEach(propertyDocument, (value, key) => {
        if (key in form) {
          this.$set(form[key], 'value', value);
        }
      });

      this.form = form;
    },
    async save() {
      const form = await this.form;

      if (!form.propertyFileTypeId.value.type) {
        this.$notify({
          title: 'Please select a file type',
          message: 'No file type selected',
          type: 'error',
        });

        this.loading = false;

        return;
      }

      if (this.$refs.form.isValidated()) {
        let expiryDate = null;
        let issueDate = null;

        if (form.propertyFileTypeId.value.hasExpiryDate
          && form.expiryDate.value
        ) {
          expiryDate = dayjs(form.expiryDate.value).format('YYYY-MM-DD');
        }

        if (form.propertyFileTypeId.value.hasExpiryDate
          && form.issueDate.value
        ) {
          issueDate = dayjs(form.issueDate.value).format('YYYY-MM-DD');
        }


        try {
          await PropertyDocument.updateType(
            this.propertyId,
            [this.propertyDocumentId],
            expiryDate,
            issueDate,
            form.propertyFileTypeId.value.propertyFileTypeId,
          );

          this.$notify({
            title: 'File type updated',
            message: 'File type has been successfully updated',
            type: 'success',
          });

          this.$emit('file-type-updated', true);
        } catch (e) {
          this.$notify({
            title: 'Error updating file type',
            message: 'File type has not been updated',
            type: 'error',
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>
